import { computed, observable } from 'mobx';
import { IAutomationStepActionFile } from '../../../types/automation.types';
import { AutomationStepActionFileBase } from './automation-step-action-file-base';
import TemplateSelectSideBarBrochure from '../../../components/Automations/AutomationsBuilder/AutomationsBuilderSideBar/SideBars/TemplateSelectSideBarBrochure';
import TemplateSelectSideBarQuestionnaire from '../../../components/Automations/AutomationsBuilder/AutomationsBuilderSideBar/SideBars/TemplateSelectSideBarQuestionnaire';
import BrochureSideBar from '../../../components/Automations/AutomationsBuilder/AutomationsBuilderSideBar/SideBars/BrochureSideBar';
import QuestionnaireSideBar from '../../../components/Automations/AutomationsBuilder/AutomationsBuilderSideBar/SideBars/QuestionnaireSideBar';
import { IAutomationSidebarConfig } from '../../../components/Automations/AutomationsBuilder/AutomationsBuilderSideBar/automation-sidebar.types';
import { AutomationActionFileType } from '../../../components/Automations/AutomationsEnums';
import AutomationBlockActionFile from '../../../components/Automations/AutomationsBuilder/AutomationsBuilderCanvas/AutomationBlockElements/AutomationBlockActionFile';

export class AutomationStepActionFile
    extends AutomationStepActionFileBase
    implements IAutomationStepActionFile
{
    @observable type: 'file';
    @observable file_type: AutomationActionFileType;

    @computed
    get fileTemplate() {
        const {
            companyStore: { currCompany }
        } = this.rootStore;

        switch (this.file_type) {
            case 'questionnaire':
                return currCompany?.getQuestionnaireTemplate(
                    this.file_template_id
                );
            case 'brochure':
                return currCompany?.getBrochureTemplate(this.file_template_id);
            default:
                return null;
        }
    }

    getSideBarConfig(): IAutomationSidebarConfig {
        return {
            initialScreen: this.file_template_id ? 'main' : 'selectFile',
            main: {
                headerProps: { title: 'Action' },
                component:
                    this.file_type === 'brochure'
                        ? BrochureSideBar
                        : QuestionnaireSideBar,
                parent: null
            },
            ...super.emailSideBarConfig,
            selectFile: {
                headerProps: {
                    title:
                        this.file_type === 'brochure'
                            ? 'Brochure template'
                            : 'Questionnaire template'
                },
                component:
                    this.file_type === 'brochure'
                        ? TemplateSelectSideBarBrochure
                        : TemplateSelectSideBarQuestionnaire,
                parent: 'main'
            }
        };
    }

    get AutomationBlockAction() {
        return AutomationBlockActionFile;
    }
}
